import { Box } from '@ally/metronome-ui'
import styled, { keyframes } from 'styled-components'

const pulseAnimation = keyframes`
  0% {
    background: rgba(128, 128, 128, 0.1);
  }
  100% {
    background: rgba(128, 128, 128, 0.2);
  }
`

export const LoadingTile = styled(Box)`
  width: 225px;
  margin-right: 12px;
`

export const LoadingRow = styled.div`
  && {
    animation: ${pulseAnimation} 1s ease-in-out alternate infinite both;
    background: rgba(128, 128, 128, 0.1);
    margin-bottom: 5px;
    width: 100%;
    height: 1rem;
  }
`
